module.exports = __webpack_public_path__ + "img/ic_recent.c1a15000.svg";